var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("目录")]),_c('div',{staticClass:"toc"},_vm._l((_vm.toc),function(item,index){return _c('div',{key:index,staticClass:"toc-item"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"pageNo"},[_vm._v(_vm._s(item.pageNo))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }